// GPS action types

// Send My Current Location
export const SEND_MY_CURRENT_LOCATION = "SEND_MY_CURRENT_LOCATION";
export const SEND_MY_CURRENT_LOCATION_SUCCESS =
  "SEND_MY_CURRENT_LOCATION_SUCCESS";
export const SEND_MY_CURRENT_LOCATION_FAILURE =
  "SEND_MY_CURRENT_LOCATION_FAILURE";
